/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { IlsWithContentAndNames } from '../../models/ils-with-content-and-names';

export interface IlsControllerFindIlsWithContentAndNames$Params {
  ilsId: string;
}

export function ilsControllerFindIlsWithContentAndNames(http: HttpClient, rootUrl: string, params: IlsControllerFindIlsWithContentAndNames$Params, context?: HttpContext): Observable<StrictHttpResponse<IlsWithContentAndNames>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerFindIlsWithContentAndNames.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<IlsWithContentAndNames>;
    })
  );
}

ilsControllerFindIlsWithContentAndNames.PATH = '/ils/{ilsId}/contentAndNames';
